import { Button, Col, Dropdown, Table, Tag, Typography } from "antd";
import {
  BranchesOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EllipsisOutlined,
  EyeOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { ItemType } from "antd/es/menu/interface";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useGetInvoices } from "../ServerSideStates";
import dayjs from "dayjs";
import PriceFormatter from "apps/Common/PriceFormatter";
import { useEffect, useState } from "react";
import { MazakaDrawer } from "apps/Common/MazakaDrawer";
import ViewInvoiceDetails from "./Details/ViewInvoiceDetails";
import { MazakaButton } from "apps/Common/MazakaButton";
import useWindowSize from "helpers/useWindowSize";

const ListItems = () => {
  const navigate = useNavigate();
  const { filter } = useSelector((state: RootState) => state.invoice);
  const invoices = useGetInvoices(filter);
  const [isShowDetailsInvoiceDrawer, setisShowDetailsInvoiceDrawer] =
    useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const windowSize = useWindowSize();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    if (windowSize.width < 1040) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  }, [windowSize.width]);

  const handleDetermineTagColor = (paymentId: number) => {
    switch (paymentId) {
      case 1:
        return "blue";
      case 2:
        return "green";
      case 3:
      case 4:
        return "error";
      default:
        return "default";
    }
  };

  const handleOpenInvoiceDetail = async (record: any) => {
    await setSelectedRecord(record);
    setisShowDetailsInvoiceDrawer(true);
  };

  const { Text } = Typography;

  const columns = [
    {
      title: "Hizmet Adı",
      dataIndex: "title",
      key: "title",
      render: (text: string, record: any) => (
        <div className="!flex justify-between w-full">
          <div className="!flex gap-1 !flex-col">
            {record?.packageList?.map((item: any) => (
              <div key={item.id} className="!flex !flex-col gap-1">
                <div
                  className="flex items-center gap-2 hover:cursor-pointer hover:text-blue-500"
                  onClick={() => handleOpenInvoiceDetail(record)}
                >
                  <FilePdfOutlined
                    className={`cursor-pointer ${
                      item.isDoping ? "text-blue-500" : "text-yellow-500"
                    } hover:text-blue-600`}
                  />
                  <span>{item.name}</span>
                </div>
              </div>
            ))}

            <div className="!flex !flex-col xl:!hidden">
              <div>
                <Tag color={handleDetermineTagColor(record.paymentStatusId)}>
                  {record?.paymentStatus?.name || ""}
                </Tag>
              </div>
              <div>
                <Button
                  icon={<EyeOutlined />}
                  onClick={() => handleOpenInvoiceDetail(record)}
                  type="text"
                  className="!text-blue-500 !border-none !p-0 !flex gap-1 !text-xs md:!text-sm !bg-transparent"
                >
                  Detayları Gör
                </Button>
              </div>
            </div>
          </div>

          <div className="!flex !flex-col gap-1 xl:!hidden">
            <div>
              <Text className="!text-gray-400 !text-xs">{record?.code}</Text>
            </div>
            <div className="!flex flex-col gap-2">
              <PriceFormatter inputPrice={record?.amount} classNames="!text-[14px]" />
            </div>
            <div>
              <Text>{record?.paymentMethod}</Text>
            </div>
          </div>
        </div>
      ),
    },
    ...(isSmallScreen
      ? []
      : [
          {
            title: "Kod",
            dataIndex: "code",
            key: "code",
            render: (value: string) => <Text>{value}</Text>,
          },
          {
            title: "Tutar",
            dataIndex: "amount",
            key: "amount",
            render: (value: number) => (
              <div className="!flex flex-col gap-2">
                <PriceFormatter inputPrice={value} />
              </div>
            ),
          },
          {
            title: "Ödeme Yöntemi",
            dataIndex: "paymentMethod",
            key: "paymentMethod",
            render: (value: string) => <Text>{value}</Text>,
          },
          {
            title: "Durum",
            dataIndex: ["paymentStatus", "name"],
            key: "durum",
            render: (text: string, record: any) =>
              text ? (
                <div className="!flex !flex-col gap-2">
                  <span>
                    <Tag color={handleDetermineTagColor(record.paymentStatusId)}>
                      {text}
                    </Tag>
                  </span>
                </div>
              ) : (
                <></>
              ),
          },
          {
            title: "Tarih",
            dataIndex: "insertDate",
            key: "insertDate",
            render: (value: string) =>
              value ? (
                <div className="!flex gap-2 items-end">
                  <div>
                    <Text className="mobile-label" data-label="Tarih">
                      {dayjs(value).format("DD.MM.YYYY")}
                    </Text>
                  </div>
                  <div>
                    <Text>{dayjs(value).format("HH:mm")}</Text>
                  </div>
                </div>
              ) : (
                <></>
              ),
          },
          {
            title: "",
            dataIndex: "edit",
            key: "edit",
            width: "8%",
            render: (_: any, record: any) => (
              <Col xs={24} className="lg:!text-end lg:pr-2">
                <Dropdown
                  className="!hidden lg:!block"
                  menu={{ items: tableItemDropdownMenu(record) }}
                >
                  <EllipsisOutlined />
                </Dropdown>
                <div className="!flex gap-2 lg:!hidden">
                  <MazakaButton
                    className="xl:hover:!bg-black xl:hover:!text-white xl:!text-black !bg-black !text-white xl:!bg-transparent"
                    icon={<EyeOutlined />}
                    onClick={() => handleOpenInvoiceDetail(record)}
                  >
                    Detayları Gör
                  </MazakaButton>
                </div>
              </Col>
            ),
          },
        ]),
  ];

  const tableItemDropdownMenu = (record: any): ItemType[] => [
    {
      key: "2",
      onClick: () => handleOpenInvoiceDetail(record),
      icon: <EyeOutlined />,
      label: "Detayları Gör",
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        loading={invoices.isLoading || invoices.isFetching}
        dataSource={invoices.data?.data?.data || []}
        rowKey={"id"}
        rowClassName="responsive-row"
        pagination={false}
      />

      <MazakaDrawer
        title={<Text className="!font-bold !text-2xl">Fatura Detayı</Text>}
        open={isShowDetailsInvoiceDrawer}
        toggleVisible={() => setisShowDetailsInvoiceDrawer(!isShowDetailsInvoiceDrawer)}
        layoutType="strecth"
      >
        <ViewInvoiceDetails selectedRecord={selectedRecord} />
      </MazakaDrawer>
    </>
  );
};

export default ListItems;
